export default __webpack_public_path__ + "static/media/expose1.9d250f64.png";